import { useState, useEffect } from "react";
import { makeRequest } from "../makeRequest";
// import { useState } from "react";

const useFetch = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const products = await makeRequest.get(url);
        setData(products.data.data);
      } catch (err) {
        // console.log(err);
        setError(true);
      }
      setLoading(false);
    };
    fetchData();
  }, [url]);

  return { data, loading, error };
};

export default useFetch;
